module.exports = __webpack_public_path__ + "static/media/lianxi.81df1e80.png";